import devCustom from './components/devCustom.vue';
export default {
  components: {
    devCustom: devCustom
  },
  data: function data() {
    return {
      //平台
      formId: 136
    };
  },
  methods: {}
};